import styled from "styled-components";

export default styled.div`
  .calendar-modal {
    .modal-content {
      width: 80vw;
      max-width: 700px;
      height: max(55vh, 420px);
      max-height: 500px;

      background-color: white;
      border-radius: 0.5rem;
      box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2rem;

      .modal-content-cont {
        height: 100%;
        display: flex;
        flex-direction: column;

        margin-left: 1rem;
        margin-right: 1rem;
        justify-content: space-between;

        .modal-event-title {
          display: flex;
        }

        .calendar-modal-button-conatiner {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .calendar-modal-buttons {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 1rem;
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .calendar-modal {
      .modal-content {
        max-width: 350px;
        max-height: 95vh;
        height: 95vh;
        width: 90vw;

        .modal-content-cont {
          .modal-event-title {
          }

          .is-full-day-checkbox {
            margin-bottom: 1rem;
          }

          .calendar-modal-button-conatiner {
            .calendar-modal-buttons {
            }
          }
        }
      }
    }
  }
`;
